import { setUserIdentifier, defineExperiment } from './actions';
import selectVariant from './selectVariant';

const initExperiments = ({ experiments, userIdentifier }) => dispatch => {
  dispatch(setUserIdentifier(userIdentifier));

  Object.keys(experiments)
    .map(key => experiments[key])
    .forEach(experiment => {
      dispatch(defineExperiment(experiment));
      dispatch(selectVariant(experiment, userIdentifier));
    });
};

export default initExperiments;
